export default __webpack_public_path__ + "0acb3e25c6b2dfb2d29a94e04954337a.svg";